// P&F Meats theme JS
document.addEventListener('DOMContentLoaded', function () {
  // Hero slideshow
  document.querySelectorAll('[data-slideshow]').forEach(function (el) {
    var slides = el.querySelectorAll('[data-slide]');
    if (slides.length < 2) return;
    var i = 0;
    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, parseInt(el.dataset.interval || '6000', 10));
  });

  // Testimonial carousel
  document.querySelectorAll('.testimonial-carousel').forEach(function (c) {
    var slides = c.querySelector('.testimonial-slides');
    var dots = c.querySelectorAll('.testimonial-dot');
    var counter = c.querySelector('.testimonial-current');
    var total = dots.length; if (!total) return;
    var i = 0;
    function go(n) {
      i = (n + total) % total;
      slides.style.transform = 'translateX(' + (-i * 100) + '%)';
      if (counter) counter.textContent = i + 1;
      dots.forEach(function (d, idx) { d.classList.toggle('is-active', idx === i); });
    }
    var prev = c.querySelector('[data-direction="prev"]');
    var next = c.querySelector('[data-direction="next"]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); }); });
    setInterval(function () { go(i + 1); }, 7000);
  });

  // FAQ accordion
  document.querySelectorAll('[data-accordion] .faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      q.parentElement.classList.toggle('is-open');
    });
  });

  // Recently viewed (localStorage)
  var RV_KEY = 'pf_recently_viewed';
  function rvGet() { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } }
  var pd = document.querySelector('[data-product-handle]');
  if (pd) {
    var h = pd.dataset.productHandle;
    var list = rvGet().filter(function (x) { return x !== h; });
    list.unshift(h);
    try { localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 8))); } catch (e) {}
  }
  document.querySelectorAll('[data-recently-viewed]').forEach(function (wrap) {
    var exclude = wrap.dataset.exclude || '';
    var handles = rvGet().filter(function (x) { return x !== exclude; }).slice(0, 4);
    if (!handles.length) {
      var empty = wrap.querySelector('.recent-empty'); if (empty) empty.hidden = false;
      return;
    }
    var grid = wrap.querySelector('.upsell-grid'); if (!grid) return;
    handles.forEach(function (hd) {
      fetch('/products/' + hd + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
        if (!p) return;
        var img = (p.featured_image || (p.images && p.images[0]) || '');
        var price = (p.price / 100).toFixed(2);
        var a = document.createElement('div');
        a.className = 'upsell-card';
        a.innerHTML = '<a href="/products/' + p.handle + '"><div class="upsell-card-img" style="background-image:url(' + img + ')"></div><h3></h3><div class="upsell-price"><span class="price">$' + price + '</span></div></a>';
        a.querySelector('h3').textContent = p.title;
        grid.appendChild(a);
      });
    });
  });

  // Pill checkboxes are CSS-only; blog sidebar search submits to /search
  document.querySelectorAll('[data-blog-search]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      var q = f.querySelector('input[name="q"]');
      if (!q.value.trim()) e.preventDefault();
    });
  });

  // Mobile nav toggle
  var burger = document.querySelector('[data-nav-toggle]');
  if (burger) burger.addEventListener('click', function () {
    document.body.classList.toggle('nav-open');
  });
});
/* ===== MOBILE FIXES — paste block (v14) ===== */
document.addEventListener('DOMContentLoaded', function () {

  /* --- Mobile nav drawer --- */
  var old = document.querySelector('[data-nav-toggle]');
  var navList = document.querySelector('.nav-links');
  if (old && navList) {
    var burger = old.cloneNode(true);          // strips any old click handler
    old.parentNode.replaceChild(burger, old);
    var scrim = document.createElement('div');
    scrim.className = 'nav-scrim';
    document.body.appendChild(scrim);
    function closeNav() { document.body.classList.remove('nav-open'); burger.setAttribute('aria-expanded', 'false'); }
    function openNav()  { document.body.classList.add('nav-open');    burger.setAttribute('aria-expanded', 'true'); }
    burger.setAttribute('aria-expanded', 'false');
    burger.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      document.body.classList.contains('nav-open') ? closeNav() : openNav();
    });
    scrim.addEventListener('click', closeNav);
    navList.addEventListener('click', function (e) { if (e.target.closest('a')) closeNav(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
    window.addEventListener('resize', function () { if (window.innerWidth > 960) closeNav(); });
  }

  /* --- Shop sidebar: turn each heading into a collapsible panel --- */
  var side = document.querySelector('.col-side');
  if (side && !side.querySelector('[data-col-acc]')) {
    var groups = [], cur = null;
    Array.prototype.slice.call(side.children).forEach(function (el) {
      if (el.tagName === 'H4') {
        cur = { head: el, body: [] }; groups.push(cur);
      } else if (el.classList && el.classList.contains('filter-block')) {
        var h = el.querySelector('h4');
        if (h) {
          groups.push({
            head: h,
            body: Array.prototype.slice.call(el.children).filter(function (c) { return c !== h; }),
            wrapper: el
          });
          cur = null;
        }
      } else if (cur) {
        cur.body.push(el);
      }
    });
    groups.forEach(function (g) {
      var d = document.createElement('details');
      d.className = 'col-acc';
      d.setAttribute('data-col-acc', '');
      var s = document.createElement('summary');
      s.innerHTML = '<span>' + g.head.textContent + '</span>';
      d.appendChild(s);
      var anchor = g.wrapper || g.head;
      anchor.parentNode.insertBefore(d, anchor);
      g.body.forEach(function (b) { d.appendChild(b); });
      g.head.remove();
      if (g.wrapper && !g.wrapper.children.length) g.wrapper.remove();
    });
    var accs = side.querySelectorAll('[data-col-acc]');
    var mq = window.matchMedia('(max-width: 900px)');
    function sync() { Array.prototype.forEach.call(accs, function (d) { d.open = !mq.matches; }); }
    sync();
    mq.addEventListener ? mq.addEventListener('change', sync) : mq.addListener(sync);
  }
});